import React from 'react';

type LogoHiProps = {
  size?: number;
  stroke?: string;
};

/**
 * HI‑SI mark: TV outline with centered "hi" text.
 * Drawn as a single SVG for pixel-perfect alignment at small sizes.
 */
const LogoHi: React.FC<LogoHiProps> = ({ size = 24, stroke = '#22D3EE' }) => {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      aria-label="HI-SI"
    >
      {/* TV outline */}
      <rect x="3.0" y="5.25" width="18" height="13.5" rx="2.25" stroke={stroke} strokeWidth="2" />
      {/* Antenna - bottom of V touches TV top */}
      <path d="M7.0 2.5l5.0 2.75 5.0-2.75" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      {/* Centered 'hi' text. y is nudged for optical centering across browsers. */}
      <text
        x="12"
        y="14.4"
        textAnchor="middle"
        fontFamily="ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace"
        fontSize="8"
        fill={stroke}
        style={{ letterSpacing: '-0.6px' }}
      >
        hi
      </text>
    </svg>
  );
};

export default LogoHi;


